import api from '../../api/api';

export const ACTION_SET_TOKENS = 'ACTION_SET_TOKENS';

export function setTokens(userId) {
    return function (dispatch) {
        api.get('/token/user/' + userId).then((resp) =>
            dispatch({
                type: ACTION_SET_TOKENS,
                payload: resp.data,
            })
        );
    };
}
export const ACTION_SET_TOKEN = 'ACTION_SET_TOKEN';

export function setToken(id) {
    return function (dispatch) {
        api.get('/token/' + id).then((resp) =>
            dispatch({
                type: ACTION_SET_TOKEN,
                payload: resp.data,
            })
        );
    };
}

export const ACTION_CREATE_TOKEN = 'ACTION_CREATE_TOKEN';

export function saveToken(dataToken) {
    return function (dispatch) {
        api.post('/token/new', dataToken).then((resp) =>
            dispatch({
                type: ACTION_CREATE_TOKEN,
                payload: resp.data,
            })
        );
    };
}
export const ACTION_UPDATE_TOKEN = 'ACTION_UPDATE_TOKEN';

export function burnToken(tokenId, gasUsed, amount = 1) {
    return function (dispatch) {
        api.patch(`/token/burn/${tokenId}`, { amount, gasUsed }).then((resp) =>
            dispatch({
                type: ACTION_UPDATE_TOKEN,
                payload: resp.data,
            })
        );
    };
}
export function transToken(tokenId, gasUsed) {
    return function (dispatch) {
        api.patch(`/token/transfer/${tokenId}`, { gasUsed }).then((resp) =>
            dispatch({
                type: ACTION_UPDATE_TOKEN,
                payload: resp.data,
            })
        );
    };
}
